import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from './nav/nav.component';
import { LayoutModule } from '@angular/cdk/layout';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { Routes, RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ExpertiseEffect } from './effects/expertise.effect';
import { ContactEffect } from './effects/contact.effect';
import { InvoiceEffect } from './effects/invoice.effect';
import { REDUCER_TOKEN, getReducers } from './reducers/index';
import { SessionInterceptor } from './interceptors/session.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
 import { MessageService } from 'primeng/api';
import { SessionEffext } from './effects/session.effect';
import { NgxPermissionsModule } from 'ngx-permissions';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [NavComponent],
  imports: [
    RouterModule,
    CommonModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatFormFieldModule,
    NgxPermissionsModule,
    StoreModule.forRoot(REDUCER_TOKEN, { }),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
  }),

    EffectsModule.forRoot([ExpertiseEffect, ContactEffect, InvoiceEffect, SessionEffext]),
  ],
  exports: [
    NavComponent,

  ],
  providers: [
        {
            provide: REDUCER_TOKEN,
            deps: [],
            useFactory: getReducers
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SessionInterceptor,
            multi: true,
        },

  ]
})
export class CoreModule { }
